import { DefaultLayout } from '@/layouts';
import { RiskAssessment } from '@/components/Analysis/RiskAssessment/RiskAssessment';
import { useGetStructureId } from '@/hooks/useGetStructureId';

export const RiskAssessmentPage = () => {
  const structureId = useGetStructureId();

  if (!structureId || structureId === '') {
    return <div>Please specify inspection id</div>;
  }

  return (
    <DefaultLayout variant="analysis">
      <RiskAssessment structureId={structureId} view="summary" />
    </DefaultLayout>
  );
};
